/* Weidelandfarm — Bildwechsel auf der Produktseite. Ohne JavaScript bleibt das Hauptbild stehen. */
(function () {
  function einrichten(galerie) {
    var haupt = galerie.querySelector('.wlf-produkt__hauptbild img');
    var thumbs = galerie.querySelectorAll('[data-wlf-thumb]');
    if (!haupt || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        haupt.removeAttribute('srcset');
        haupt.src = thumb.dataset.wlfThumb;
        var bild = thumb.querySelector('img');
        if (bild) haupt.alt = bild.alt;
        thumbs.forEach(function (t) {
          t.classList.toggle('wlf-produkt__thumb--aktiv', t === thumb);
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-wlf-galerie]').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
